exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".activitiesPage{margin-top:30px}.activitiesPage .doneLoadingNotice{text-align:center;border:1px solid #ddd;border-radius:5px;padding:5px 10px;margin:0 auto;max-width:650px}.activitiesPage .filterControls{margin-left:-10px;margin-bottom:5px;float:left}.activitiesPage .helpSectionLink{padding-top:.8em}.activitiesPage .displayToggleControl{text-align:right;font-size:16px;margin-bottom:15px}.activitiesPage .activeBar{top:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/activities/activities_page.scss
// module id = 1459
// module chunks = 0